import ClassInvoicesPage from '@pages/ClassInvoicesPage';
import LoginPage from '@pages/LoginPage';
import MainFeedPage from '@pages/MainFeedPage';
import PaymentStatementsPage from '@pages/PaymentStatementsPage';
import ProductCollectionsPage from '@pages/ProductCollectionsPage';
import ProductsPage from '@pages/ProductsPage';
import PushNotificationPage from '@pages/PushNotificationPage';
import BannersPage from '@pages/BannersPage';
import UsersPage from '@pages/UsersPage';
import AdminUserPage from '@pages/AdminUserPage';
import Dashboard from '@pages/Dashboard';
import FeedElementsPage from '@pages/FeedElementsPage';
import ChatMessagesPage from '@pages/ChatMessagesPage';
import ViolationDetectedMessagesPage from '@pages/ViolationDetectedMessagesPage';
import CouponLogsPage from '@pages/CouponLogsPage';
import CouponsPage from '@pages/CouponsPage';
import DiscountCouponsPage from '@pages/DiscountCouponsPage';
import PointTemplatesPage from '@pages/PointTemplatesPage';
import CustomerRequestsPage from '@pages/CustomerRequestsPage';
import UserContentsPage from '@pages/UserContentsPage';
import ChatRoomsPage from '@pages/ChatRoomsPage';
import ChatRoomsV2Page from '@pages/ChatRoomsV2Page';
import CreditPointLogsPage from '@pages/CreditPointLogsPage';
import NaverOrdersPage from '@pages/SalesChannelNaverOrdersPage';
import NoticesPage from '@pages/NoticesPage';
import RedirectPage from './RedirectPage';
import KakaoNotificationsPage from '@pages/KakaoNotificationsPage';
import RemoteConfigPage from '@pages/RemoteConfigPage';
import NaverCommerceOrdersPage from '@pages/NaverCommerceOrdersPage';
import JoinPromotionsPage from '@pages/JoinPromotionsPage';
import JoinPromotionLogsPage from '@pages/JoinPromotionLogsPage';
import KakaoReservedNotificationsPage from '@pages/KakaoReservedNotificationsPage';
import SystemPaymentsPage from '@pages/SystemPaymentsPage';
import EventsPage from '@pages/EventsPage';
import NaverCommerceProductsPage from '@pages/NaverCommerceProductsPage';
import ProductReportPage from '@pages/ProductsReportPage';
import ProductExposureReportPage from '@pages/ProductsExposureReportPage';
import ProductsInventoryPage from '@pages/ProductsInventoryPage';
import ProductInventoryClosingHistoryPage from '@pages/ProductInventoryClosingHistoryPage';
import ProductOrdersPage from '@pages/ProductOrdersPage';
import SettlementsPage from '@pages/SettlementsPage';
import ReviewEventPage from '@pages/ReviewEventPage';
import ReviewEventDetailPage from '@pages/ReviewEventDetailPage';
import UserEventRecordsPage from '@pages/UserEventRecordsPage';
import { CustomerBenefitEventsPage } from '@pages/CustomerBenefitEventsPage';
import PaymentTemplatePage from '@pages/PaymentTemplatePage';
import SalesReportPage from '@pages/SalesReportPage';
import PurchasesReportPage from '@pages/PurchasesReportPage';
import MembershipsPage from '@pages/MembershipsPage';
import MembershipUsersPage from '@pages/MembershipUsersPage';
import CommissionRateTemplatesPage from '@pages/CommissionRateTemplatesPage';
import ProgramSchedulesPage from '@pages/ProgramSchedulesPage';
import SqsMessageManagementPage from '@pages/SqsMessageManagementPage';
import ProgramScheduleGroupsPage from '@pages/ProgramScheduleGroupsPage';
import GroupingAgentRunsPage from '@pages/GroupingAgentRunsPage';
import GroupingAgentRunDetailPage from '@pages/GroupingAgentRunDetailPage';
import ReservationSuccessBatchRunsPage from '@pages/ReservationSuccessBatchRunsPage';
import ReservationSuccessBatchRunDetailPage from '@pages/ReservationSuccessBatchRunDetailPage';
import ReservationSuccessProductIndicatorsPage from '@pages/ReservationSuccessProductIndicatorsPage';
import PilotReportPage from '@pages/PilotReportPage';
import ReservationSuccessDashboardPage from '@pages/ReservationSuccessDashboardPage';
import ReservationSuccessAlertsPage from '@pages/ReservationSuccessAlertsPage';
import GroupMonitoringPage from '@pages/GroupMonitoringPage';
import LastChanceMonitoringPage from '@pages/LastChanceMonitoringPage';
import ProgramReportsPage from '@pages/ProgramReportsPage';
import ProgramInvoicesPage from '@pages/ProgramInvoicesPage';
import ProductClusteringPage from '@pages/ProductClusteringPage';
import PartnerUsersPage from '@pages/PartnerUsersPage';
import NaverCommerceMonitoringPage from '@pages/NaverCommerceMonitoringPage';
import ProductOrdersRefundSchedulePage from '@pages/ProductOrdersRefundSchedulePage';
import UserDiscountCouponsPage from '@pages/UserDiscountCouponsPage';
import Utility from '@pages/Utility';
import IntegrationApisPage from '@pages/IntegrationApisPage';
import MainFeedV2Page from '@pages/MainFeedV2Page';
import NetSalesReportPage from '@pages/NetSalesReportPage';
import BenepiaUsersPage from '@pages/BenepiaUsersPage';
import BenepiaBannersPage from '@pages/BenepiaBannersPage';
import AffiliatesPage from '@pages/AffiliatesPage';
import { PageProtectedRoute } from '@components/common/ProtectedRoute';
import { CommentMonitoringPage } from '@pages/CommentMonitoringPage';
import CampaignsPage from '@pages/CampaignsPage';
import TimeSalesPage from '@pages/TimeSalesPage';
import DealsPage from '@pages/DealsPage';

const routes = [
  {
    path: '/dashboard',
    element: (
      <PageProtectedRoute path="/dashboard">
        <Dashboard />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/notices',
    element: (
      <PageProtectedRoute path="/notices">
        <NoticesPage />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/remote-config',
    element: (
      <PageProtectedRoute path="/remote-config">
        <RemoteConfigPage />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/sqs-message-management',
    element: (
      <PageProtectedRoute path="/sqs-message-management">
        <SqsMessageManagementPage />
      </PageProtectedRoute>
    ),
  },
  { path: '/login', element: <LoginPage /> },
  {
    path: '/product-orders',
    element: (
      <PageProtectedRoute path="/product-orders">
        <ProductOrdersPage />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/payment-statements',
    element: (
      <PageProtectedRoute path="/payment-statements">
        <PaymentStatementsPage />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/payment-templates',
    element: (
      <PageProtectedRoute path="/payment-templates">
        <PaymentTemplatePage />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/settlements',
    element: (
      <PageProtectedRoute path="/settlements">
        <SettlementsPage />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/payments',
    element: (
      <PageProtectedRoute path="/payments">
        <SystemPaymentsPage />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/products',
    element: (
      <PageProtectedRoute path="/products">
        <ProductsPage />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/products-inventory',
    element: (
      <PageProtectedRoute path="/products-inventory">
        <ProductsInventoryPage />
      </PageProtectedRoute>
    ),
  },
  {
    path: 'product-inventory-closing-history',
    element: (
      <PageProtectedRoute path="/product-inventory-closing-history">
        <ProductInventoryClosingHistoryPage />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/users',
    element: (
      <PageProtectedRoute path="/users">
        <UsersPage />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/admin-users',
    element: (
      <PageProtectedRoute path="/admin-users">
        <AdminUserPage />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/partner-users',
    element: (
      <PageProtectedRoute path="/partner-users">
        <PartnerUsersPage />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/benepia/users',
    element: (
      <PageProtectedRoute path="/benepia/users">
        <BenepiaUsersPage />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/benepia/banners',
    element: (
      <PageProtectedRoute path="/benepia/banners">
        <BenepiaBannersPage />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/class-invoices',
    element: (
      <PageProtectedRoute path="/class-invoices">
        <ClassInvoicesPage />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/program-invoices',
    element: (
      <PageProtectedRoute path="/program-invoices">
        <ProgramInvoicesPage />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/program-schedules',
    element: (
      <PageProtectedRoute path="/program-schedules">
        <ProgramSchedulesPage />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/program-schedule-groups',
    element: (
      <PageProtectedRoute path="/program-schedule-groups">
        <ProgramScheduleGroupsPage />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/grouping-agent-runs',
    element: (
      <PageProtectedRoute path="/grouping-agent-runs">
        <GroupingAgentRunsPage />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/grouping-agent-runs/:runId',
    element: (
      <PageProtectedRoute path="/grouping-agent-runs">
        <GroupingAgentRunDetailPage />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/reservation-success-batch-runs',
    element: (
      <PageProtectedRoute path="/reservation-success-batch-runs">
        <ReservationSuccessBatchRunsPage />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/reservation-success-batch-runs/:runId',
    element: (
      <PageProtectedRoute path="/reservation-success-batch-runs">
        <ReservationSuccessBatchRunDetailPage />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/reservation-success-product-indicators',
    element: (
      <PageProtectedRoute path="/reservation-success-product-indicators">
        <ReservationSuccessProductIndicatorsPage />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/reservation-success-metrics',
    element: (
      <PageProtectedRoute path="/reservation-success-metrics">
        <PilotReportPage />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/reservation-success',
    element: (
      <PageProtectedRoute path="/reservation-success">
        <ReservationSuccessDashboardPage />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/reservation-success-alerts',
    element: (
      <PageProtectedRoute path="/reservation-success-alerts">
        <ReservationSuccessAlertsPage />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/group-monitoring',
    element: (
      <PageProtectedRoute path="/group-monitoring">
        <GroupMonitoringPage />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/last-chance-monitoring',
    element: (
      <PageProtectedRoute path="/last-chance-monitoring">
        <LastChanceMonitoringPage />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/program-reports',
    element: (
      <PageProtectedRoute path="/program-reports">
        <ProgramReportsPage />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/push-notifications',
    element: (
      <PageProtectedRoute path="/push-notifications">
        <PushNotificationPage />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/kakao-notifications',
    element: (
      <PageProtectedRoute path="/kakao-notifications">
        <KakaoNotificationsPage />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/kakao-reserved-notifications',
    element: (
      <PageProtectedRoute path="/kakao-reserved-notifications">
        <KakaoReservedNotificationsPage />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/product-collections',
    element: (
      <PageProtectedRoute path="/product-collections">
        <ProductCollectionsPage />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/customer-benefit-events',
    element: (
      <PageProtectedRoute path="/customer-benefit-events">
        <CustomerBenefitEventsPage />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/main-feed',
    element: (
      <PageProtectedRoute path="/main-feed">
        <MainFeedPage />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/campaigns',
    element: (
      <PageProtectedRoute path="/campaigns">
        <CampaignsPage />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/time-sales',
    element: (
      <PageProtectedRoute path="/time-sales">
        <TimeSalesPage />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/deals',
    element: (
      <PageProtectedRoute path="/deals">
        <DealsPage />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/main-feed-v2',
    element: (
      <PageProtectedRoute path="/main-feed-v2">
        <MainFeedV2Page />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/banners',
    element: (
      <PageProtectedRoute path="/banners">
        <BannersPage />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/feed-elements',
    element: (
      <PageProtectedRoute path="/feed-elements">
        <FeedElementsPage />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/chat-messages',
    element: (
      <PageProtectedRoute path="/chat-messages">
        <ChatMessagesPage />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/chat-rooms',
    element: (
      <PageProtectedRoute path="/chat-rooms">
        <ChatRoomsPage />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/chat-rooms-v2',
    element: (
      <PageProtectedRoute path="/chat-rooms-v2">
        <ChatRoomsV2Page />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/violation-detected-messages',
    element: (
      <PageProtectedRoute path="/violation-detected-messages">
        <ViolationDetectedMessagesPage />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/user-contents',
    element: (
      <PageProtectedRoute path="/user-contents">
        <UserContentsPage />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/comment-monitoring',
    element: (
      <PageProtectedRoute path="/comment-monitoring">
        <CommentMonitoringPage />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/review-events',
    element: (
      <PageProtectedRoute path="/review-events">
        <ReviewEventPage />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/review-events/:id',
    element: (
      <PageProtectedRoute path="/review-events">
        <ReviewEventDetailPage />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/customer-request',
    element: (
      <PageProtectedRoute path="/customer-request">
        <CustomerRequestsPage />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/user-event-records',
    element: (
      <PageProtectedRoute path="/user-event-records">
        <UserEventRecordsPage />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/point-template',
    element: (
      <PageProtectedRoute path="/point-template">
        <PointTemplatesPage />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/coupon',
    element: (
      <PageProtectedRoute path="/coupon">
        <CouponsPage />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/discount-coupon',
    element: (
      <PageProtectedRoute path="/discount-coupon">
        <DiscountCouponsPage />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/user-discount-coupon',
    element: (
      <PageProtectedRoute path="/user-discount-coupon">
        <UserDiscountCouponsPage />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/coupon-log',
    element: (
      <PageProtectedRoute path="/coupon-log">
        <CouponLogsPage />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/point-log',
    element: (
      <PageProtectedRoute path="/point-log">
        <CreditPointLogsPage />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/join-promotion',
    element: (
      <PageProtectedRoute path="/join-promotion">
        <JoinPromotionsPage />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/join-promotion-log',
    element: (
      <PageProtectedRoute path="/join-promotion-log">
        <JoinPromotionLogsPage />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/naver-orders',
    element: (
      <PageProtectedRoute path="/naver-orders">
        <NaverOrdersPage />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/naver-commerce-orders',
    element: (
      <PageProtectedRoute path="/naver-commerce-orders">
        <NaverCommerceOrdersPage />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/naver-commerce-products',
    element: (
      <PageProtectedRoute path="/naver-commerce-products">
        <NaverCommerceProductsPage />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/report/products',
    element: (
      <PageProtectedRoute path="/report/products">
        <ProductReportPage />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/report/product-exposure',
    element: (
      <PageProtectedRoute path="/report/product-exposure">
        <ProductExposureReportPage />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/report/sales',
    element: (
      <PageProtectedRoute path="/report/sales">
        <SalesReportPage />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/report/purchases',
    element: (
      <PageProtectedRoute path="/report/purchases">
        <PurchasesReportPage />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/report/net-sales-report',
    element: (
      <PageProtectedRoute path="/report/net-sales-report">
        <NetSalesReportPage />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/events',
    element: (
      <PageProtectedRoute path="/events">
        <EventsPage />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/memberships',
    element: (
      <PageProtectedRoute path="/memberships">
        <MembershipsPage />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/membership-users',
    element: (
      <PageProtectedRoute path="/membership-users">
        <MembershipUsersPage />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/commission-rate-template',
    element: (
      <PageProtectedRoute path="/commission-rate-template">
        <CommissionRateTemplatesPage />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/product-clustering',
    element: (
      <PageProtectedRoute path="/product-clustering">
        <ProductClusteringPage />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/naver-commerce-monitoring',
    element: (
      <PageProtectedRoute path="/naver-commerce-monitoring">
        <NaverCommerceMonitoringPage />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/product-orders-refund-schedule',
    element: (
      <PageProtectedRoute path="/product-orders-refund-schedule">
        <ProductOrdersRefundSchedulePage />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/integration-apis',
    element: (
      <PageProtectedRoute path="/integration-apis">
        <IntegrationApisPage />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/utility',
    element: (
      <PageProtectedRoute path="/utility">
        <Utility />
      </PageProtectedRoute>
    ),
  },
  {
    path: '/affiliates',
    element: (
      <PageProtectedRoute path="/affiliates">
        <AffiliatesPage />
      </PageProtectedRoute>
    ),
  },

  { path: '*', element: <RedirectPage /> },
];

export default routes;
